import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, Menu } from 'antd';
import { ClickableIcon } from '../../../common/components';
import { ThreeDotsIcon } from '../../../custom_shared/icons';
import { WorksheetModel } from '../../models';
import { useAppStore } from '../../stores';

interface Props {
    worksheet: WorksheetModel;
}

const WorksheetActionsDropdown: React.FC<Props> = ({ worksheet }) => {
    const { controlStateStore, worksheetsSubmissionStore } = useAppStore();

    const [menuVisible, setMenuVisible] = React.useState(false);

    if (worksheet.isLocked) {
        return null;
    }

    const moreActionsMenu = (
        <Menu onClick={() => setMenuVisible(false)}>
            <Menu.Item
                key="send-to-sics"
                disabled={controlStateStore.actionsDisabled || worksheet.hasValidationError}
                onClick={() => worksheetsSubmissionStore.processSingleWorksheet(worksheet)}
            >
                Send to SICS
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown
            placement="topLeft"
            visible={menuVisible}
            overlay={moreActionsMenu}
            onVisibleChange={setMenuVisible}
            trigger={['click']}
            arrow
        >
            <ClickableIcon
                width={20}
                height={20}
                icon={ThreeDotsIcon}
                onClick={() => setMenuVisible(true)}
                style={{ marginRight: -3 }}
            />
        </Dropdown>
    );
};

export default observer(WorksheetActionsDropdown);
